import {
	Box,
	Card,
	CardContent,
	Grid,
	Tooltip,
	Typography,
} from '@mui/material';

import { TAXONOMY_TAB_VALUES } from 'common/constants/TaxonomyConstants';

import {
	getChipFormattedData,
	getFooterInfo,
	getPrcCardEntityId,
	getPrcCardTitle,
	getPrcCardTitleTwo,
} from '../../RiskRefTaxonomyUtils';

import { RiskRefCardData } from '../../../api/type-def';

import RiskRefTaxonomyIndustryChipView from './RiskRefTaxonomyIndustryChipView';

import styles from './RiskRefTaxonomyCard.module.scss';

interface IRiskRefTaxonomyCardProps {
	data: RiskRefCardData;
	category: TAXONOMY_TAB_VALUES;
	handleNavigate: (
		data: RiskRefCardData,
		category: TAXONOMY_TAB_VALUES,
	) => void;
}
const RiskRefTaxonomyCard = (props: IRiskRefTaxonomyCardProps) => {
	const { data, category, handleNavigate } = props;

	return (
		<div>
			<Card
				className={styles[`riskref-card-${category}`]}
				onClick={() => handleNavigate(data, category)}
				data-testid="riskref-card-process-level"
			>
				<CardContent
					data-testid="riskref-card-process-card"
					className={styles[`riskref-card-${category}-content`]}
				>
					<Grid container direction="column">
						<Typography
							className={styles[`riskref-card-entity-id-${category}`]}
							mt={1}
						>
							{getPrcCardEntityId(data, category)
								? getPrcCardEntityId(data, category)
								: ''}
						</Typography>

						<div className={styles['riskref-card-entity-name-container']}>
							<Tooltip
								title={getPrcCardTitle(data, category)}
								placement="bottom-start"
							>
								<Box
									className={styles[`riskref-card-entity-name-${category}`]}
									mt={1}
								>
									{getPrcCardTitle(data, category)}
								</Box>
							</Tooltip>
						</div>
						{getPrcCardTitleTwo(data, category) && (
							<div
								className={
									styles[`riskref-card-entity-titletwo-container-${category}`]
								}
							>
								<Tooltip
									title={getPrcCardTitleTwo(data, category)}
									placement="bottom-start"
								>
									<Box
										className={styles['riskref-card-titletwo-entity-name']}
										mt={1}
									>
										{getPrcCardTitleTwo(data, category)}
									</Box>
								</Tooltip>
							</div>
						)}

						<RiskRefTaxonomyIndustryChipView
							className={styles[`riskref-chip-container-${category}`]}
							data={getChipFormattedData(
								data,
								category,
								styles['riskref-chip-text'],
							)}
						/>

						<>{getFooterInfo(data, category)}</>
					</Grid>
				</CardContent>
			</Card>
		</div>
	);
};

export default RiskRefTaxonomyCard;
